module.exports = __webpack_public_path__ + "img/ekt.bef516c6.png";